/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItDataTypeBooleanDtoValue } from './TrackItDataTypeBooleanDtoValue';
import {
    TrackItDataTypeBooleanDtoValueFromJSON,
    TrackItDataTypeBooleanDtoValueFromJSONTyped,
    TrackItDataTypeBooleanDtoValueToJSON,
} from './TrackItDataTypeBooleanDtoValue';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface TrackItDataTypeBooleanDto
 */
export interface TrackItDataTypeBooleanDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeBooleanDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeBooleanDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeBooleanDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeBooleanDto
     */
    definition?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TrackItDataTypeBooleanDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataTypeBooleanDto
     */
    readonly commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeBooleanDto
     */
    readonly lastComment?: string | null;
    /**
     * 
     * @type {TrackItDataTypeBooleanDtoValue}
     * @memberof TrackItDataTypeBooleanDto
     */
    value?: TrackItDataTypeBooleanDtoValue | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataTypeBooleanDto
     */
    $type?: TrackItDataTypeBooleanDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItDataTypeBooleanDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItDataTypeBooleanDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeBooleanDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItDataTypeBooleanDtoTypeEnum = typeof TrackItDataTypeBooleanDtoTypeEnum[keyof typeof TrackItDataTypeBooleanDtoTypeEnum];



/**
 * Check if a given object implements the TrackItDataTypeBooleanDto interface.
 */
export function instanceOfTrackItDataTypeBooleanDto(value?: unknown): value is TrackItDataTypeBooleanDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItDataTypeBooleanDtoTypeEnum)[0];
}

export function TrackItDataTypeBooleanDtoFromJSON(json: any): TrackItDataTypeBooleanDto {
    return TrackItDataTypeBooleanDtoFromJSONTyped(json, false);
}

export function TrackItDataTypeBooleanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataTypeBooleanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'definition': json['definition'] == null ? undefined : json['definition'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'value': json['value'] == null ? undefined : TrackItDataTypeBooleanDtoValueFromJSON(json['value']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItDataTypeBooleanDtoToJSON(value?: Omit<TrackItDataTypeBooleanDto, 'commentCount'|'lastComment'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'definition': value['definition'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'value': TrackItDataTypeBooleanDtoValueToJSON(value['value']),
        '$type': value['$type'],
    });
}

